const PROBE_TIMEOUT_MS = 20000;

/**
 * Lit la durée réelle d'une vidéo via l'élément HTML <video> (événement loadedmetadata),
 * comme dans le labeler vidéo.
 */
export const probeVideoDurationSec = (url: string): Promise<number | null> => {
  if (!url || typeof document === "undefined") {
    return Promise.resolve(null);
  }

  return new Promise((resolve) => {
    const video = document.createElement("video");
    video.preload = "metadata";
    video.muted = true;
    video.setAttribute("playsinline", "");

    let settled = false;
    const finish = (value: number | null) => {
      if (settled) return;
      settled = true;
      window.clearTimeout(timeoutId);
      video.onloadedmetadata = null;
      video.onloadeddata = null;
      video.ondurationchange = null;
      video.onerror = null;
      video.removeAttribute("src");
      video.load();
      resolve(value);
    };

    const timeoutId = window.setTimeout(() => finish(null), PROBE_TIMEOUT_MS);

    const readDuration = () => {
      const duration = video.duration;
      if (Number.isFinite(duration) && duration > 0) {
        finish(duration);
        return true;
      }
      return false;
    };

    video.onloadedmetadata = () => {
      if (!readDuration()) {
        video.ondurationchange = () => {
          readDuration();
        };
      }
    };

    video.onloadeddata = () => {
      readDuration();
    };

    video.onerror = () => finish(null);
    video.src = url;
  });
};

export const chartDurationSecFromExact = (durationExactSec: number): number =>
  Math.max(Math.ceil(durationExactSec), 1);
